import angular from 'angular';

function OnDelete() {
  return {
    restrict: 'A',
    link: function (scope, element, attrs) {
      element.bind('keydown keypress', function (event) {
        if (event.which === 8) {
          scope.$eval(attrs.fbOnDelete);
          event.preventDefault();
          event.stopImmediatePropagation();
        }
      });
    }
  };
}

export default angular.module('directives.on-delete', [])
  .directive('fbOnDelete', OnDelete)
  .name;



// WEBPACK FOOTER //
// ./project/directives/fb-on-delete/index.js